import React                  from 'react';
import PropTypes              from 'prop-types';
import Edit                   from '../../../../api-platform-admin/src/Edit_MVT';
import { makeStyles }         from '@material-ui/core';
import MuiModal               from '../../../components/common/MuiModal';
import GlobalLoadingIndicator from '../components/GlobalLoadingIndicator';

let useStyles = makeStyles(function (theme) {
	return ({
		drawerContent: {
			width: '100%',
			[theme.breakpoints.up('xs')]: {
				width: '100%',
			},
			[theme.breakpoints.up('sm')]: {
				width: '100%',
			},
		}
	});
});

function MuiModalEditor(props) {

	let styles = useStyles();
	const {
		disableBackdropClick,
		title,
		closeButton,
		isOpen,
		handleEditorClose,
		resource,
		id,
		basePath,
		redirect,
		formProps,
		options,
		contentWidth,
		contentMinWidth,
		contentMaxWidth,
		maxWidth,
		dialogContentStyle,
	} = props;

	// if(typeof console === 'object') { console.log('MuiModalEditor',isOpen); }


	return (
		<MuiModal
			draggable={true}
			disableBackdropClick={disableBackdropClick}
			closeButton={closeButton}
			contentWidth={contentWidth}
			contentMinWidth={contentMinWidth}
			contentMaxWidth={contentMaxWidth}
			maxWidth={maxWidth}
			open={isOpen}
			onClose={handleEditorClose}
			title={<React.Fragment>
				{title}
				<GlobalLoadingIndicator />
			</React.Fragment>}
			dialogContentStyle={Object.assign({
				padding: 0,
				borderBottom: 0,
			},dialogContentStyle)}
		>
			{isOpen ? (
				<React.Fragment>
					<Edit
						// toolbar={null}
						renderFields="editfields"
						className={styles.drawerContent}
						id={isOpen ? id : null}
						resource={resource}
						basePath={basePath}
						options={options}
						// redirect={false}
						onCancel={handleEditorClose}
						formProps={Object.assign({
							redirect: redirect,
						},formProps)}

					/>
				</React.Fragment>
			) : (
				 <div className={styles.drawerContent} />
			 )}
		</MuiModal>
	);
};

MuiModalEditor.defaultProps = {
	dialogContentStyle: {},
	formProps: {},
	disableBackdropClick: false,
};

MuiModalEditor.propTypes = {
	title: PropTypes.string,
	closeButton: PropTypes.bool,
	disableBackdropClick: PropTypes.bool,
	isOpen: PropTypes.bool,
	resource: PropTypes.string,
	basePath: PropTypes.string,
	id: PropTypes.any,
	redirect: PropTypes.any,
	contentWidth: PropTypes.any,
	contentMaxWidth: PropTypes.any,
	contentMinWidth: PropTypes.any,
	maxWidth: PropTypes.any,
	options: PropTypes.object,
	formProps: PropTypes.object,
	dialogContentStyle: PropTypes.object,
	handleEditorClose: PropTypes.func
};

export default MuiModalEditor;
// export default withStyles(styles)(withTranslate(ComponentTemplate));
// export default withTranslate(ComponentTemplate);
// export default connect(null,null)(withTranslate(ComponentTemplate));
